export const coinsColors: { [k: string]: string } = {
  atom: "#2a2d46ff",
  icp: "#29abe2ff",
  dai: "#fab830",
  btc: "#f7931aff",
  link: "#2a5adaff",
  bnb: "#f0bb03ff",
  vet: "#23008dff",
  bch: "#02c28fff",
  rndr: "#d00709ff",
  xmr: "#f2681cff",
  uni: "#feeef5ff",
  matic: "#8345e6ff",
  etc: "#3cba3cff",
  hbar: "#f0f2f5",
  near: "#00ec97ff",
  grt: "#4963c3",
  aave: "#36b7be",
  crv: "#81ff78ff",
  rpl: "#ff8166",
  ape: "#2252d2",
  sui: "#eaf7ffff",
  ccs: "#5ce2e7ff",
  neo: "#00e69aff",
  fil: "#0091ffff",
  usdc: "#2276cbff",
  okb: "#f0f2f5",
  cro: "#002975ff",
  usdp: "#005221",
  frax: "#f0f2f5",
  ltc: "#838383ff",
  chz: "#ff0955ff",
  mana: "#ff6e58",
  doge: "#bca130fe",
  kcs: "#1db192ff",
  xtz: "#2c7df7ff",
  apt: "#f0f2f5",
  wbt: "#1b1814ff",
  bit: "#adff00ff",
  arb: "#213148ff",
  egld: "#51f7dd",
  algo: "#f0f2f5",
  busd: "#f0bb03ff",
  leo: "#060017ff",
  xlm: "#f0f2f5",
  eth: "#626890ff",
  steth: "#f4f6f8ff",
  axs: "#0067acff",
  gt: "#d45656ff",
  inj: "#00ccfdff",
  ceth: "#1398d5",
  mina: "#e46632",
  sol: "#4ff89c",
  dot: "#e7007bff",
  avax: "#e93f40ff",
  tusd: "#145affff",
  qnt: "#f0f2f5",
  ftm: "#1269ffff",
  edgt: "#14e5ffff",
  sand: "#00adefff",
  eos: "#f0f2f5",
  flow: "#00ef8bff",
  snx: "#00d2ffff",
  imx: "#f0f2f5",
  xrd: "#0128c1ff",
  gala: "#f0f2f5",
  usdd: "#216c58ff",
  reth: "#ff7c7f",
  xrp: "#f0f2f5",
  stx: "#5444ffff",
  cfx: "#1a1a1aff",
  op: "#ff001aff",
  btt: "#f0f2f5",
  mkr: "#13ad9dff",
  klay: "#ff8400ff",
  theta: "#2bb8e6",
  lunc: "#f9d75dff",
  dash: "#008ce7",
  xaut: "#d4b259ff",
  bsv: "#e8b321ff",
  tkx: "#ff671f",
  woo: "#0f1925ff",
  flr: "#e51a57ff",
  xdc: "#1f4a82ff",
  xec: "#0075c3ff",
  bgb: "#feffffff",
  gmx: "#00bee0ff",
  cspr: "#e1372d",
  kava: "#ff554fff",
  fxs: "#f0f2f5",
  ht: "#2ea7e0ff",
  miota: "#131f37ff",
  twt: "#2f76bdff",
  zil: "#4ac1bfff",
  paxg: "#f9f9f9ff",
  gusd: "#27def9",
  ldo: "#ea837cff",
  trx: "#c53027ff",
  usdt: "#009494ff",
  ada: "#1f6cd4fe",
  wbtc: "#f4f4f4ff",
};

export const chartDefaultColorsHex = [
  "#224DDA",
  "#232892",
  "#FF1744",
  "#FFA93A",
  "#232892",
  "#E6007A",
  "#A05ACE",
  "#FFAB00",
  "#00B8D4",
  "#F7931A",
  "#5D4037",
  "#00BFA5",
  "#00C853",
  "#616161",
  "#C6FF00",
  "#455A64",
];
